import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { GameStatus } from '@perplexicon/api-client';

import { apiClient } from './api-client.js';
import { GAME_CATALOG_QUERY_KEY } from '../features/games/query-keys.js';

export const ADMIN_GAMES_QUERY_KEY = ['admin', 'games'] as const;
export const ADMIN_HEALTH_QUERY_KEY = ['admin', 'health'] as const;

export function useAdminGames() {
  return useQuery({ queryKey: ADMIN_GAMES_QUERY_KEY, queryFn: () => apiClient.admin.listGames() });
}

export function useSetGameStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ gameId, status }: { gameId: string; status: GameStatus }) =>
      apiClient.admin.setGameStatus(gameId, status),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ADMIN_GAMES_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: GAME_CATALOG_QUERY_KEY });
    },
  });
}

export function useAdminHealth() {
  return useQuery({ queryKey: ADMIN_HEALTH_QUERY_KEY, queryFn: () => apiClient.admin.health() });
}

export function useAdminSessionInspection(sessionId: string) {
  return useQuery({
    queryKey: ['admin', 'session', sessionId],
    queryFn: () => apiClient.admin.inspectSession(sessionId),
    enabled: sessionId.length > 0,
    retry: false,
  });
}
